import { cn } from '@/lib/cn';

export interface NexaWordmarkProps {
  className?: string;
}

/**
 * The "NEXA" wordmark, traced from the brand lockup (mvp/ui/public/nexa-logo.svg).
 * Letterforms are drawn in `currentColor` so the wordmark inherits the surface's
 * text colour and stays legible in either theme; only the cyan notch inside the
 * X keeps a fixed brand colour, exactly as the source lockup does.
 */
export function NexaWordmark({ className }: NexaWordmarkProps) {
  return (
    <svg
      viewBox="434.14 187.62 615.05 107.09"
      className={cn('block w-auto', className)}
      aria-hidden
      data-testid="nexa-wordmark"
    >
      <g fill="currentColor">
        <path d="M434.14,187.62h42.84l65.79,89.63v-89.63h24.79v107.09h-42.84l-65.79-89.78v89.78h-24.79v-107.09Z" />
        <path d="M604.79,187.62h107.73v19h-80v24.5h80v18.19h-80v26.4h80v19h-107.73v-107.09Z" />
        <path d="M794,240.73l-54.57-53.1h30.96l40.39,38.95h.29l39.39-38.95h30.96l-54.57,53.1,54.57,53.98h-31.18l-39.17-39.39h-.29l-40.17,39.39h-32.18l55.57-53.98Z" />
        <path d="M950.4,187.62h43.13l55.3,107.09h-30.66l-11.52-22.96h-69.17l-11.52,22.96h-30.66l55.08-107.09ZM996.98,252.54l-24.79-49.29h-.44l-24.64,49.29h49.88Z" />
      </g>
      <polygon fill="#0b99de" points="795 240.73 812.07 226.57 827.84 240.73 811.78 255.32 795 240.73" />
    </svg>
  );
}
